var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDarkBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#335C75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 23V35H25V23H29V35H33V23H37V35H39.25C39.4489 35 39.6397 35.079 39.7803 35.2197C39.921 35.3603 40 35.5511 40 35.75V37H14V35.75C14 35.5511 14.079 35.3603 14.2197 35.2197C14.3603 35.079 14.5511 35 14.75 35H17V23H21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6912 18.5386L27.1912 13.0386C27.0688 12.9879 26.9312 12.9879 26.8088 13.0386L12.3088 18.5386C12.2174 18.5764 12.1393 18.6405 12.0843 18.7227C12.0294 18.8049 12 18.9016 12 19.0004V20.0004C12 20.1331 12.0527 20.2602 12.1464 20.354C12.2402 20.4478 12.3674 20.5004 12.5 20.5004H14V21.2504C14 21.4494 14.079 21.6401 14.2197 21.7808C14.3603 21.9214 14.5511 22.0004 14.75 22.0004H39.25C39.4489 22.0004 39.6397 21.9214 39.7803 21.7808C39.921 21.6401 40 21.4494 40 21.2504V20.5004H41.5C41.6326 20.5004 41.7598 20.4478 41.8536 20.354C41.9473 20.2602 42 20.1331 42 20.0004V19.0004C42 18.9016 41.9706 18.8049 41.9157 18.7227C41.8607 18.6405 41.7826 18.5764 41.6912 18.5386ZM40.5 38.0004H13.5C13.1022 38.0004 12.7206 38.1585 12.4393 38.4398C12.158 38.7211 12 39.1026 12 39.5004V40.5004C12 40.6331 12.0527 40.7602 12.1464 40.854C12.2402 40.9478 12.3674 41.0004 12.5 41.0004H41.5C41.6326 41.0004 41.7598 40.9478 41.8536 40.854C41.9473 40.7602 42 40.6331 42 40.5004V39.5004C42 39.1026 41.842 38.7211 41.5607 38.4398C41.2794 38.1585 40.8978 38.0004 40.5 38.0004Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkBank);
export default __webpack_public_path__ + "static/media/icon-dark-bank.d478dd40.svg";
export { ForwardRef as ReactComponent };